import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { ApiVehicle } from "Types/api/Vehicle";
import { PaymentTypeOptions, VehicleState } from "Types/state";

/**
 * POST Vehicle request/success/failure
 */
export const postVehicleRequest = actionCreator(
    "vehicle/post/request",
    (
        uuid: string,
        vin: string,
        currentVehicles: {
            [vin: string]: VehicleState;
        },
        paymentType?: PaymentTypeOptions
    ) => ({
        uuid,
        vin,
        paymentType,
        currentVehicles,
    }),
    () => ({ route: API.Deal })
);

export const postVehicleSuccess = actionCreator("vehicle/post/success", (vehicle: ApiVehicle) => ({
    vehicle,
}));

export const postVehicleFailure = actionCreator(
    "vehicle/post/failure",
    (vin: string, reason: "vehicle_exists" | "vehicle_limit" | "unexpected_issue") => ({
        vin,
        reason,
    })
);

/**
 * POST Vehicle Rating request/success/failure
 */
export const postVehicleRatingRequest = actionCreator(
    "vehicle_rating/post/request",
    (uuid: string, vin: string, rating: number, prevRating?: number) => ({
        uuid,
        vin,
        rating,
        prevRating,
    }),
    () => ({ route: API.Vehicles })
);

export const postVehicleRatingSuccess = actionCreator("vehicle_rating/post/success", (vin: string) => ({
    vin,
}));

export const postVehicleRatingFailure = actionCreator(
    "vehicle_rating/post/failure",
    (vin: string, rating?: number) => ({
        vin,
        rating,
    })
);

/**
 * DELETE Vehicle request/success/failure
 */
export const deleteVehicleRequest = actionCreator(
    "vehicle/delete/request",
    (uuid: string, vin: string) => ({
        uuid,
        vin,
    }),
    () => ({ route: API.Vehicles })
);

export const deleteVehicleSuccess = actionCreator("vehicle/delete/success", (vin: string) => ({ vin }));

export const deleteVehicleFailure = actionCreator("vehicle/delete/failure", (vin: string) => ({ vin }));
